import loadable from "@loadable/component";
import SwitchTab from "../../components/Reusable/SwitchTab";
const StockLedgerComponent = loadable(
  () => import("../../components/InventoryReport/StockLedger")
);
const StockLedger = () => {
  const tabs = [
    {
      id: "stock-ledger-normal",
      label: "Normal",
      href: "/accounting/stock-ledger-normal",
    },
    {
      id: "stock-ledger-detail",
      label: "Detail",
      href: "/accounting/stock-ledger-detail",
    },
  ];
  return (
    <>
      <SwitchTab tabs={tabs} />
      <StockLedgerComponent />
    </>
  );
};

export default StockLedger;
